/** Library content, legacy services and line items have independent ID sequences. */
export const getLibraryItemIdentity = (item) => {
  if (item.kind === 'lineitem') {
    return { kind: 'lineitem', id: item.lineitemid };
  }
  if (item.isservice || item.itineraryserviceid) {
    return { kind: 'service', id: item.itineraryserviceid ?? item.contentid };
  }
  return { kind: 'content', id: item.contentid };
};

export const getLibraryItemKey = (item) => {
  const { kind, id } = getLibraryItemIdentity(item);
  return `${kind}-${id}`;
};
